import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type NoFilesWarningDialogProps = {
  onContinue: () => void;
  onClose: () => void;
};

export default function NoFilesWarningDialog({
  onContinue,
  onClose,
}: NoFilesWarningDialogProps) {
  return (
    <DefaultDialog
      variant="warning"
      confirmLabel="Continue"
      title="No files selected"
      message="Continue without selecting any files?"
      onCancel={onClose}
      onConfirm={onContinue}
      onClose={onClose}
    />
  );
}
